import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import {
  Button,
  Input,
  Container,
  ContainerText,
  Content,
  LockerIcon,
  Loader,
  ErrorMessage,
} from './styles';

const PasswordDialog = (props) => {
  const {
    loading,
    error,
    onSubmit,
  } = props;

  if (loading) {
    return (
      <Container>
        <Content>
          <Loader data-loader="password-loader" />
        </Content>
      </Container>
    );
  }

  return (
    <Formik
      initialValues={{ password: '' }}
      validationSchema={Yup.object().shape({
        password: Yup.string().required('Password is required'),
      })}
      onSubmit={(values) => {
        onSubmit(values.password);
      }}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
      }) => (
        <Container>
          <Content>
            <Form>
              <LockerIcon src="/images/locker.png" />
              <ContainerText>This content is protected.</ContainerText>
              <ContainerText>To view, please enter the password.</ContainerText>
              <Input
                type="text"
                name="password"
                placeholder="Enter the password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.name}
              />
              <Button type="submit">Submit</Button>
              {errors.password && <ErrorMessage color="#9F3A38">{errors.password}</ErrorMessage>}
              {error && <ErrorMessage color="#9F3A38">{error}</ErrorMessage>}
            </Form>
          </Content>
        </Container>
      )}
    </Formik>
  );
};

PasswordDialog.propTypes = {
  error: PropTypes.string,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
};

PasswordDialog.defaultProps = {
  error: null,
  loading: false,
  onSubmit: () => { },
};

export default PasswordDialog;
